import { render, staticRenderFns } from "./EmployeeSalarySettingEdit.vue?vue&type=template&id=40ff0074&scoped=true&"
import script from "./EmployeeSalarySettingEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeSalarySettingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff0074",
  null
  
)

export default component.exports